import Autolinker from 'autolinker';

export const formatLinks = (text, options = null) => {
  const autolinker = new Autolinker({
    truncate: 40,
    replaceFn: match => {
      if (match.getType() === 'url') {
        const url = match.getUrl();
        const filename = filenameFromUrl(url);
        if (filename) {
          const tag = match.buildTag();
          tag.setInnerHtml(filename);
          return tag;
        }
      }
      return true;
    },
  });
  return autolinker.link(text, options);
};

export const escapeRegExp = string => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const escapeHtml = unsafe => {
  if (!unsafe) return '';

  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

export const stringEmpty = str => !str || str.trim().length === 0;

export const filenameFromUrl = url => {
  try {
    const pathname = new URL(url).pathname;
    const raw = pathname.split('/').pop();
    if (raw && raw.includes('.')) {
      return decodeURIComponent(raw.replace(/\+/g, ' '));
    }
  } catch (e) { /* ignore */ }
  return null;
};



// WEBPACK FOOTER //
// ./app/javascript/common/utils/text.js